import { z } from 'zod';

// --- Feeding enums ---

export const FeedingGroupSchema = z.enum(['milking', 'dry', 'heifers', 'other']);
export type FeedingGroup = z.infer<typeof FeedingGroupSchema>;

export const BunkStatusSchema = z.enum([
  'clean',
  'little_left',
  'good_bit_left',
  'all_eaten',
  'sloppy',
]);
export type BunkStatus = z.infer<typeof BunkStatusSchema>;

// --- Event enums ---

export const EventTypeSchema = z.enum([
  'calving',
  'breeding',
  'preg_check',
  'dry_off',
  'health',
  'death',
  'sold',
  'group_change',
  'note',
]);
export type EventType = z.infer<typeof EventTypeSchema>;

// --- Alert enums ---

export const AlertTypeSchema = z.enum([
  'calving_due',
  'low_inventory',
  'overdue_breeding',
  'overdue_preg_check',
  'overdue_dry_off',
  'unusual_feeding',
]);
export type AlertType = z.infer<typeof AlertTypeSchema>;

export const AlertSeveritySchema = z.enum(['info', 'warning', 'urgent']);
export type AlertSeverity = z.infer<typeof AlertSeveritySchema>;

export interface Alert {
  alert_id: string;
  type: AlertType;
  severity: AlertSeverity;
  subject_id: string;
  subject_name: string;
  message: string;
  action_suggestion: string;
  data: Record<string, unknown>;
}

// --- View enums ---

export const ViewTypeSchema = z.enum([
  'line_chart',
  'bar_chart',
  'stacked_bar',
  'pie_chart',
  'scatter',
  'gauge',
  'calendar',
  'table',
  'kpi_card',
  'alert_list',
  'markdown',
  'heatmap',
]);
export type ViewType = z.infer<typeof ViewTypeSchema>;
